export function debounced<A extends Array<any>>(delay: number, fn: (...args: A) => void) {
  let timerId: NodeJS.Timeout | null;
  return (...args: A) => {
    if (timerId) {
      clearTimeout(timerId);
    }
    timerId = setTimeout(() => {
      fn(...args);
      timerId = null;
    }, delay);
  };
}

export function camelToSnakeCase(str: string) {
  return str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
}

export function omitBy(obj: any, filterFn: (value: any, key: string) => boolean) {
  return Object.keys(obj)
    .filter((key) => !filterFn(obj[key], key))
    .reduce((res: any, key) => {
      res[key] = obj[key];
      return res;
    }, {});
}

export function getUTCDateDiffInSeconds(dateTo: Date, dateFrom: Date) {
  const timeRemainingInSeconds = Math.floor((dateFrom.getTime() - dateTo.getTime()) / 1000);
  return timeRemainingInSeconds;
}
